import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { doc, setDoc, getDoc, deleteDoc, deleteField } from 'firebase/firestore';
import { db } from '../../firebase/firebase';

/* save calendar settings to db, overwrite existing */
export const saveCalendarSettings = createAsyncThunk(
  'calendar-settings/saveCalendarSettings',
  async ({ uid, data }) => {
    console.log('saveCalendarSettings', uid, data);

    try {
      const docRef = doc(db, 'users', uid, 'calendarSettings', 'settings');
      await setDoc(docRef, { ...data, bookingsAdvance: deleteField() }, { merge: true });
      console.log('SAVED SETTINGS', data);
      return data;
    } catch (error) {
      console.error('Error saving settings:', error);
      return error;
    }
  }
);

export const fetchOwnCalendarSettings = createAsyncThunk(
  'calendar-settings/fetchOwnCalendarSettings',
  async (uid) => {
    try {
      const docRef = doc(db, 'users', uid, 'calendarSettings', 'settings');
      const settings = await getDoc(docRef);
      return settings.data();
    } catch (error) {
      return error;
    }
  }
);

export const removeCalendarSettings = createAsyncThunk(
  'calendar-settings/removeCalendarSettings',
  async (uid, { rejectWithValue }) => {
    try {
      const docRef = doc(db, 'users', uid, 'calendarSettings', 'settings');
      await deleteDoc(docRef);
      return `Settings for user ${uid} removed successfully.`;
    } catch (error) {
      console.error('Error removing settings:', error);
      return rejectWithValue(error);
    }
  }
);

export const fetchSellerCalendarSettings = createAsyncThunk(
  'calendar-settings/fetchSellerCalendarSettings',
  async (uid) => {
    try {
      const settings = await getDoc(doc(db, 'users', uid, 'data', 'calendarSettings'));
      return settings.data();
    } catch (error) {
      return error;
    }
  }
);

const initialState = {
  settings: {},
  bookingsettings: {}
};

export const calendarSettingsSlice = createSlice({
  name: 'calendar-settings',
  initialState,
  reducers: {
    resetCalendarSettings: () => initialState
  },
  extraReducers: (builder) => {
    builder
      .addCase(saveCalendarSettings.fulfilled, (state, action) => {
        state.settings = action.payload;
      })
      .addCase(fetchOwnCalendarSettings.fulfilled, (state, action) => {
        state.settings = action.payload;
      })
      .addCase(fetchSellerCalendarSettings.fulfilled, (state, action) => {
        state.bookingsettings = action.payload;
      })
      .addCase(removeCalendarSettings.fulfilled, (state, action) => {
        console.log(action.payload);
        return initialState;
      });
  }
});

export const { resetCalendarSettings } = calendarSettingsSlice.actions;
export default calendarSettingsSlice.reducer;
